"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tappedConfirmArtwork = void 0;

var _Schema = require("../../Schema");

/**
 * A user tapped the confirm offer CTA in an inquiry
 *
 * @example
 * ```
 * tappedConfirmArtwork()
 * ```
 *
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var tappedConfirmArtwork = function tappedConfirmArtwork() {
  return {
    context_module: _Schema.OwnerType.conversationMakeOfferConfirmArtwork,
    context_owner_type: _Schema.OwnerType.conversation
  };
};

exports.tappedConfirmArtwork = tappedConfirmArtwork;